﻿import { Button, Play } from '@core/ui';
import { useTranslation } from 'react-i18next';

export const WebinarButtonStart = ({ onClick, disabled }: { onClick: () => void; disabled?: boolean }) => {
    const { t } = useTranslation();

    return (
        <Button type="button" variant="success" onClick={onClick} disabled={disabled}>
            <Play classNames="h-4 fill-current" />
            <span className="sr-only bc:not-sr-only bc:ml-3">{t('Broadcaster.Button.Start')}</span>
        </Button>
    );
};
